const translation = {
    "cancel": "בטל",
    "save": "שמור"
  };

  export default translation;
  